import React, { useState } from 'react';

import { Box } from '@mui/material';
import { Home, Soap, Ptinfo, Ptdoc, Search } from './components';
import PageHeaderTabs from '../Common/components/PageHeaderTabs';
import {
  patientPageContentSx,
  patientPageRootSx
} from '../Common/components/Styles/PatientPageStyles';
import { patients } from './data';
import TabContainer from './components/TabContainer';
import PatientSearchPopover from './components/PatientSearchPopover';
import { patientTabs } from './components/patientTabs';

const Default = () => {
  const [value, setValue] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [patientSearch, setPatientSearch] = useState('');
  const openPatientSearch = Boolean(anchorEl);

  const handleChange = (event, newValue) => {
    if (newValue === 1 && !selectedPatient) {
      setAnchorEl(event.currentTarget);
      return;
    }
    setValue(newValue);
  };

  const handleSelectPatient = patient => {
    setSelectedPatient(patient);
    setPatientSearch('');
    setAnchorEl(null);
    setValue(1);
  };

  const handleClosePatientSearch = () => {
    setAnchorEl(null);
    setPatientSearch('');
  };

  const renderTabContent = () => {
    switch (value) {
      case 0:
        return <Home />;

      case 1:
        return <Soap selectedPatient={selectedPatient} />;

      case 2:
        return <Ptinfo selectedPatient={selectedPatient} />;

      case 3:
        return <Ptdoc selectedPatient={selectedPatient} />;

      case 4:
        return <Search />;

      default:
        return null;
    }
  };

  return (
    <Box sx={patientPageRootSx}>
      <PageHeaderTabs
        type="tabs"
        value={value}
        tabs={patientTabs}
        onChange={handleChange}
      />

      <Box sx={patientPageContentSx}>
        <TabContainer>{renderTabContent()}</TabContainer>
      </Box>

      <PatientSearchPopover
        open={openPatientSearch}
        anchorEl={anchorEl}
        patients={patients}
        search={patientSearch}
        onSearchChange={event => setPatientSearch(event.target.value)}
        onClose={handleClosePatientSearch}
        onSelectPatient={handleSelectPatient}
      />
    </Box>
  );
};

export default Default;
